<template>
  <v-text-field
    v-model="search"
    flat
    solo-inverted
    hide-details
    clearable
    prepend-inner-icon="mdi-magnify"
    :label="getLabel('search')"
    transition="scale-transition"
    @keyup.enter="enterSearch"
  />
</template>

<script>
import { ref } from '@vue/composition-api';
import { useRouter, useRoute } from 'vue2-helpers/vue-router';
import { getLabel } from '@/utils/index';

import { useMainStore } from '@/store/index';

export default {
  setup () {
    const store = useMainStore();

    const search = ref(store.search.query);

    const router = useRouter();

    const route = useRoute();

    const enterSearch = () => {
      store.search.query = search.value;
      store.search.page = 1;

      const searchObject = route.meta.search === 'group' ? 'groupsDashboard' : 'dashboard';
      if (search.value === '') {
        router.push({ name: searchObject }).catch(error => {
          if (error.name !== 'NavigationDuplicated') {
            throw error;
          }
        });
        return;
      }

      if (route.meta.search === 'group') {
        router.push({ name: 'groupsSearch', params: { query: search.value } }).catch(error => {
          if (error.name !== 'NavigationDuplicated') {
            throw error;
          }
        });
        return;
      }

      router.push({ name: 'search', params: { query: search.value } }).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error;
        }
      });
    };

    return { getLabel, search, enterSearch };
  }

};

</script>
